/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {EventEmitter} from 'events';

import _request from './request';

/**
 * @param {Object} options
 * @returns {Promise}
 */
export default function request(options) {
  if (options.url) {
    options.uri = options.url;
    options.url = null;
  }

  options.headers = options.headers || {};

  options.download = new EventEmitter();
  options.upload = new EventEmitter();

  return intercept(options.interceptors, 'Request')
    .then((...args) => _request(options, ...args))
    .then((...args) => intercept(options.interceptors.slice().reverse(), 'Response', ...args));

  /**
   * @param {Array} interceptors
   * @param {string} key
   * @param {Object} res
   * @private
   * @returns {Promise}
   */
  function intercept(interceptors, key, res) {
    const successKey = `on${key}`;
    const errorKey = `on${key}Error`;

    return interceptors.reduce(
      (promise, interceptor) =>
        promise.then(
          (result) => {
            interceptor.logOptions(options);
            if (interceptor[successKey]) {
              return interceptor[successKey](options, result);
            }

            return Promise.resolve(result);
          },
          (reason) => {
            interceptor.logOptions(options);
            if (interceptor[errorKey]) {
              return interceptor[errorKey](options, reason);
            }

            return Promise.reject(reason);
          }
        ),
      Promise.resolve(res)
    );
  }
}
